import { useDynamicContext } from "@dynamic-labs/sdk-react-core";
import type { WalletIconVariant } from "@kyan/ui";
import { WalletIcon } from "@kyan/ui";

import { useEoa } from "#/store/wallet/eoa/eoa";
import { formatAddress } from "#/utils/formatAddress";

export const WalletInfo: React.FC = () => {
  const { primaryWallet } = useDynamicContext();
  const { eoa } = useEoa();

  return (
    <div className="border-divider bg-buttonHover flex items-center gap-2 rounded-sm border p-3 text-xs">
      <WalletIcon
        size="md"
        variant={
          primaryWallet?.connector.name.toLowerCase() as WalletIconVariant
        }
      />
      {formatAddress(eoa, 6, 4)}
    </div>
  );
};
